import { render, staticRenderFns } from "./VocabularyAdd.vue?vue&type=template&id=47de1c7a&scoped=true&"
import script from "./VocabularyAdd.vue?vue&type=script&lang=js&"
export * from "./VocabularyAdd.vue?vue&type=script&lang=js&"
import style0 from "./VocabularyAdd.vue?vue&type=style&index=0&id=47de1c7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47de1c7a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCol,VImg,VRow,VSelect,VSpacer,VSwitch,VTextarea})
